const API_URL: string = import.meta.env.VITE_API_URL
const BUGSNAG_API_KEY: string = import.meta.env.VITE_BUGSNAG_API_KEY
const ENVNAME: string = import.meta.env.VITE_ENVNAME

export { API_URL, BUGSNAG_API_KEY, ENVNAME }
